<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!loading">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive" style="overflow: visible">
              <table
                class="
                  table
                  mt-2
                  dt-responsive
                  nowrap
                  w-100
                  dataTable
                  no-footer
                  dtr-inline
                "
                style="overflow: visible"
              >
                <thead class="table-light">
                  <tr>
                    <th style="width: 30%">Name</th>
                    <th style="width: 100%">Description</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(tag, index) in listTags" :key="index">
                    <td>
                      <span
                        class="badge me-2"
                        :style="'background-color:' + tag.color"
                      >
                        {{ tag.name }}
                      </span>
                    </td>
                    <td>{{ tag.description }}</td>
                    <td>
                      <div class="ms-auto text-end">
                        <a
                          class="
                            btn btn-link
                            text-danger text-gradient
                            px-3
                            mb-0
                          "
                          href="javascript:;"
                          @click="
                            $bvModal.show('delete_tag_modal' + tag.tag_id)
                          "
                          ><i
                            class="far fa-trash-alt me-2"
                            aria-hidden="true"
                          ></i
                          >Delete</a
                        >
                        <a
                          class="btn btn-link text-dark px-3 mb-0"
                          href="javascript:;"
                          @click="editTag(tag)"
                          ><i
                            class="fas fa-pencil-alt text-dark me-2"
                            aria-hidden="true"
                          ></i
                          >Edit</a
                        >
                      </div>

                      <b-modal
                        :id="'delete_tag_modal' + tag.tag_id"
                        hide-footer
                      >
                        <template #modal-header>
                          <h6 class="text-center">DELETE {{ tag.name }}</h6>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            :disabled="loadingAction"
                            @click="
                              $bvModal.hide('delete_tag_modal' + tag.tag_id)
                            "
                          ></button>
                        </template>

                        <div class="modal-body">
                          <h3 class="text-center">Are you sure?</h3>
                          <h6 class="text-center">
                            You won't be able to revert this.
                          </h6>
                          <div class="d-grid gap-2 d-md-block text-center">
                            <form method="POST">
                              <input
                                type="hidden"
                                name="csrfmiddlewaretoken"
                                value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                              />
                              <button
                                class="btn btn-danger waves-effect waves-light"
                                type="button"
                                name="delete_bid"
                                value="11"
                                @click="deleteTag(tag.tag_id)"
                              >
                                Delete
                              </button>
                              <button
                                class="btn btn-light waves-effect waves-light"
                                type="button"
                                data-bs-dismiss="modal"
                                @click="
                                  $bvModal.hide('delete_tag_modal' + tag.tag_id)
                                "
                              >
                                Cancel
                              </button>
                            </form>
                          </div>
                        </div>
                      </b-modal>
                    </td>

                    <!-- Start Modal -->

                    <!-- End Modal -->
                  </tr>
                </tbody>
              </table>
            </div>
            <p></p>
            <button
              class="btn btn-success me-md-2"
              type="button"
              v-b-modal.tag-create
            >
              Create Tag
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="tag-create" hide-footer body-class="p-0" @hide="onHide">
      <template #modal-header>
        <h5 class="modal-title">Tags Creation</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          :disabled="loadingAction"
          @click="$bvModal.hide('tag-create')"
        ></button>
      </template>

      <form
        @submit.prevent="onSubmitTag"
        novalidate
        :class="
          submittedTag ? 'needs-validation was-validated' : 'needs-validation'
        "
      >
        <div class="modal-body">
          <div class="row">
            <!-- Start Col -->
            <div class="col-lg-10">
              <div class="mb-3">
                <label for="name_id">Name*</label>
                <input
                  type="text"
                  name="name"
                  id="name_id"
                  class="form-control"
                  required=""
                  v-model.trim="$v.tag_name.$model"
                />

                <div
                  v-if="submittedTag && !$v.tag_name.required"
                  class="invalid-tooltip"
                >
                  This field is required
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="mb-3">
                <label for="color_id">Color*</label>
                <div
                  class="picker-input"
                  v-click-outside-element="
                    showPicker ? (showPicker = false) : null
                  "
                >
                  <input
                    type="color"
                    required
                    v-model.trim="$v.color.$model"
                    class="form-control form-control-color"
                    @click.stop="showPicker = true"
                  />
                  <div
                    v-if="submittedTag && !$v.color.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                  <div class="picker-box" v-if="showPicker">
                    <sketch-picker
                      @input="updateValue"
                      :value="color"
                      :preset-colors="[
                        '#f00',
                        '#00ff00',
                        '#00ff0055',
                        'rgb(201, 76, 76)',
                        'rgba(0,0,255,1)',
                        'hsl(89, 43%, 51%)',
                        'hsla(89, 43%, 51%, 0.6)',
                      ]"
                    ></sketch-picker>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Col -->
          </div>
          <div class="row">
            <!-- Start Col -->
            <div class="col-lg-12">
              <div class="mb-3">
                <label for="description_id">Description</label>
                <textarea
                  name="description"
                  v-model.trim="$v.description.$model"
                  cols="40"
                  rows="3"
                  id="description_id"
                  class="form-control"
                  required
                ></textarea>
                <div
                  v-if="submittedTag && !$v.description.required"
                  class="invalid-tooltip"
                >
                  This field is required
                </div>
              </div>
            </div>
            <!-- End Col -->
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light waves-effect"
            data-bs-dismiss="modal"
            @click="$bvModal.hide('tag-create')"
            :disabled="loadingAction"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-success waves-effect waves-light"
            name="create_tag"
            value="create_tag"
            data-bs-dismiss="modal"
            :disabled="loadingAction"
          >
            Save
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { utilService } from '../services/util.service'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { Sketch } from 'vue-color'

export default {
  name: 'Tags',
  components: {
    'sketch-picker': Sketch
  },
  data () {
    return {
      loading: true,
      loadingAction: false,
      listTags: [],
      tag_name: '',
      description: '',
      color: '#222',
      closePicker: false,
      showPicker: false,
      submittedTag: false,
      isEdit: false,
      tag_id: null
    }
  },
  validations: {
    tag_name: { required },
    description: { required },
    color: { required }
  },
  computed: {},
  created () {
    utilService.getTag().then((tags) => {
      this.listTags = tags.results
      this.loading = false
    })
  },
  methods: {
    moment,
    editTag (tag) {
      this.tag_id = tag.tag_id
      this.isEdit = true
      this.tag_name = tag.name
      this.color = tag.color
      this.description = tag.description
      this.$bvModal.show('tag-create')
    },
    onSubmitTag () {
      this.submittedTag = true
      // stop here if form is invalid
      this.$v.description.$touch()
      this.$v.tag_name.$touch()
      this.$v.color.$touch()
      if (
        this.$v.description.$invalid ||
        this.$v.tag_name.$invalid ||
        this.$v.color.$invalid
      ) {
        return
      }
      //
      this.loadingAction = true
      const payload = {
        name: this.tag_name,
        color: this.color,
        description: this.description
      }
      if (this.isEdit) {
        utilService.updateTag(payload, this.tag_id).then((rs) => {
          this.listTags = this.listTags.map((e) => {
            if (e.tag_id === rs.tag_id) {
              e = rs
            }
            return e
          })
          this.$bvModal.hide('tag-create')
        })
      } else {
        utilService.addTag(payload).then((rs) => {
          this.listTags.push(rs)
          this.$bvModal.hide('tag-create')
        })
      }
    },
    deleteTag (id) {
      this.loadingAction = true
      utilService.deleteTag(id).then((rs) => {
        this.listTags = this.listTags.filter((e) => e.tag_id !== id)
        this.loadingAction = false
      })
    },
    onHide () {
      this.isEdit = false
      this.color = '#222'
      this.tag_name = ''
      this.description = ''
      this.tag_id = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Tags.vue